//const finalDate = new Date('09/08/2022 11:00:00');
export const finalDate = new Date('10/06/2022 11:00:00');
// export const finalDate = new Date('10/06/2300 11:00:00');
// export const finalDate = new Date('09/07/2022 22:00:00');

export const daysToMs = 24 * 60 * 60 * 1000;
export const hoursToMs = 60 * 60 * 1000;
export const minutesToMs = 60 * 1000;
export const secondsToMs = 1000;
